module.exports = __webpack_public_path__ + "img/GeraltUndRoach.ce23d95b.svg";